<template>
  <path pid="0" d="M13 2a11 11 0 1011 11A11 11 0 0013 2zm0 20a9 9 0 119-9 9 9 0 01-9 9z"/><path pid="1" d="M13 6a7 7 0 107 7 7 7 0 00-7-7zm0 12a5 5 0 115-5 5 5 0 01-5 5z"/><path pid="2" d="M13 10a3 3 0 103 3 3 3 0 00-3-3zm0 4a1 1 0 111-1 1 1 0 01-1 1z"/>
</template>
